import React from "react";
import { Card, Table } from "react-bootstrap";
import UltimatePagination from "../../../partials/layout/PaginationComponent";
import { formatDateTime, formatTimeTaken } from "../../../../_metronic";

const PsActivity = ({ psActivity,
    totalRecords,
    currentPage,
    limit,
    onPageChange
}) => {
    return (
        <Card>
            <Card.Header>Window 2 - PS Activity</Card.Header>

            <Card.Body className="table-scroll">
                <Table bordered hover>
                    <thead>
                        <tr>
                            <th>Property</th>
                            <th>PS Name</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Time Taken</th>
                        </tr>
                    </thead>

                    <tbody>
                        {psActivity.map((item, index) => (
                            <tr key={index}>
                                <td>{item.formattedHouseName}</td>
                                <td>{item.psName}</td>
                                <td>{formatDateTime(item.startTime)}</td>
                                <td>{formatDateTime(item.endTime)}</td>
                                <td>{formatTimeTaken(item.timeTaken)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                {totalRecords > limit && (
                    <UltimatePagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(totalRecords / limit)}
                        onChange={onPageChange}
                    />
                )}
            </Card.Body>
        </Card>
    );
};

export default PsActivity;